module.exports = __webpack_public_path__ + "static/media/ic_image.b55b57e8.svg";